import { UILocale, UILocaleDefaults, UILocaleProvider } from "@tlc/ui/UILocale";
import React from "react";

export interface FormsLocale extends UILocale {
  checkboxGroup: {
    required: (label?: React.ReactNode, singularLabel?: string) => string;
    selectAll: string;
    selectedDescription: (checkedCount: number, totalCount: number) => string;
  };
  singleSelect: {
    required: (label?: React.ReactNode) => string;
  };
  formTextField: {
    required: (label: string) => string;
    maxLength: (label: string, maxLength: number) => string;
  };
}

export const FormsLocaleDefaults: FormsLocale = {
  ...UILocaleDefaults,
  checkboxGroup: {
    required: (label?: React.ReactNode, singularLabel?: string) =>
      "At least one option is required.",
    selectAll: "Select All",
    selectedDescription: (checkedCount: number, totalCount: number) =>
      `${checkedCount} of ${totalCount} selected`,
  },
  singleSelect: {
    required: (label?: React.ReactNode) => {
      return typeof label === "string"
        ? `${label} is required.`
        : "This field cannot be blank.";
    },
  },
  formTextField: {
    required: (label: string) => {
      return `${label} is required.`;
    },
    maxLength: (label: string, maxLength: number) => {
      return `${label} cannot exceed ${maxLength} characters.`;
    },
  },
};

export const FormsLocaleContext = React.createContext<FormsLocale>(null);

export const FormsLocaleProvider: React.FC<{
  locale: FormsLocale;
  children: React.ReactNode;
}> = ({ locale, children }) => {
  return (
    <UILocaleProvider locale={locale}>
      <FormsLocaleContext.Provider value={locale}>
        {children}
      </FormsLocaleContext.Provider>
    </UILocaleProvider>
  );
};

export function useFormsLocale(): FormsLocale {
  const value = React.useContext(FormsLocaleContext);
  if (!value) {
    throw new Error("FormsLocaleProvider is missing.");
  }
  return value;
}
